import React from 'react';

import { Auth } from 'aws-amplify'

import AuthCard from './AuthCard';

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment'

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const strength = require('zxcvbn');

class NewPasswordHandler extends React.Component {
    state = {
        loading: false,
        password: '',
        passwordVisible: false,
        helpText: 'Password must be at least 8 characters long',
        helpTextClass: null
    }

    handlePasswordVisibilityMouseDown = event => {
        event.preventDefault();
    };

    togglePasswordVisibility = () => {
        this.setState(state => ({ passwordVisible: !state.passwordVisible }));
    };

    handleInputChange = e => {
        this.setState({ password: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();
        const { user } = this.props;
        const { password } = this.state;
        this.setState({ loading: true }, () => {
            Auth.completeNewPassword(user, password).then(data => {
                this.props.onStateChange('user_signin_complete');
            }).catch(signInErr =>
                this.setState({ helpText: signInErr.message, helpTextClass: 'error', loading: false  }));
        });
    }


    render() {
        const { loading, password, passwordVisible ,helpText, helpTextClass } = this.state;
        const { placeholder } = this.props;
        const passwordStrength = strength(password);
        return (
            <form onSubmit={this.handleSubmit}>
                <AuthCard loading={loading} {...this.props} title="Log in to Connect" subheader="Password change required"
                    helpText={helpText} helpTextClass={helpTextClass} >
                    <Grid container spacing={24}>
                        <Grid item xs>
                            <TextField
                                id="login_password" name="login_password" value={password} autoComplete="off"
                                placeholder={placeholder} fullWidth autoFocus disabled={loading}
                                onChange={this.handleInputChange} margin="normal" type={passwordVisible ? "text" : "password"}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this.togglePasswordVisibility}
                                            onMouseDown={this.handlePasswordVisibilityMouseDown}
                                        >
                                            {passwordVisible ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <FormControl margin="normal">
                                <Button variant="contained" color="secondary" disabled={loading} onClick={this.handleSubmit}>Go</Button>
                            </FormControl>
                        </Grid>

                    </Grid>
                    <LinearProgress variant="determinate" value={25 * passwordStrength.score} />
                </AuthCard>
            </form>
        )
    }
}
export default NewPasswordHandler;


// WEBPACK FOOTER //
// ./src/Components/Authentication/AuthParts/NewPasswordHandler.js